<template>
    <!-- 推荐产品轮播图 -->
    <div class="hot">
        <div class="center m_center hot_center">
            <div class="header column_center">
                <div class="title">{{ isIndex ? '推荐产品' : '热门推荐' }}</div>
                <div class="line"></div>
            </div>
            <div class="hot_content" @mouseenter="enterFn" @mouseleave="leaveFn">
                <swiper ref="mySwiper" :options="swiperOptions">
                    <swiper-slide v-for="(item, index) in list" :key="index" class="left_center">
                            <div class="p_item" v-for="(aitem, aindex) in item" :key="aindex">
                                <router-link :to="{ name: 'production_detail', query: { id: aitem.id } }" class="td_none">
                                    <div class="img_box r_position">
<!--                                        <router-link :to="{ name: 'production_detail', query: { id: aitem.id } }" class="td_none">-->
<!--                                            <div class="mask flex flex-dir-left flex-main-center flex-cross-center a_position l_0 r_0 leave_slowly hover_slowly">-->
<!--                                                <div class="buy_btn row_center leave_slowly hover_slowly">-->
<!--                                                    立即购买-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </router-link>-->
                                        <img :src="aitem.image" alt="">
                                    </div>
                                    <div class="txt w column_center">
                                        <div class="title w d_ellipsis ta_center">{{ aitem.store_name }}</div>
                                        <div class="price w d_ellipsis ta_center">{{ '￥' + aitem.price }}</div>
                                    </div>
                                </router-link>
                            </div>
                    </swiper-slide>
                    <div class="msl-prev row_center pointer hover_slowly leave_slowly" slot="button-prev">
                        <span class="iconfont iconleft prev_icon"></span>
                    </div>
                    <div class="msl-next row_center pointer hover_slowly leave_slowly" slot="button-next">
                        <span class="iconfont iconright next_icon"></span>
                    </div>
                </swiper>
            </div>
            <div class="more_area row_center">
                <router-link to="./production" class="row_center td_none">
                    <div class="more row_center pointer hover_slowly leave_slowly">更多商品</div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay, Navigation ,EffectFade,EffectCoverflow} from 'swiper/core'
    SwiperClass.use([Pagination, Mousewheel, Autoplay,Navigation,EffectFade,EffectCoverflow])
    import 'swiper/swiper-bundle.min.css'
    import {hotPro, proDetail} from "../api/common";
    export default {
        name: "hot_production",
        data() {
            return {
                list: [], // 推荐产品
                swiperOptions: {
                    autoplay: {
                        delay: 3000, // 自动切换的时间间隔（单位ms）
                        disableOnInteraction: false,  // 用户操作swiper之后，是否禁止autoplay
                    },
                    // autoplay: true,
                    loop: true,
                    navigation: {
                        nextEl: ".msl-next",
                        prevEl: ".msl-prev",
                    },
                    //滑动速度
                    speed: 1000,
                },
                swiperArr: [
                    {
                        img: '../assets/pc_pic/index/pro_1.png'
                    },
                    {
                        img: '../assets/pc_pic/index/pro_2.png'
                    },
                    {
                        img: '../assets/pc_pic/index/pro_3.png'
                    }
                ]
            }
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.$swiper
            }
        },
        mounted() {
            this.getList();
            // console.log('Current Swiper instance object', this.swiper)
            // this.swiper();
        },
        props: {
            isIndex: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            getList () {
                try {
                    hotPro().then(res => {
                        if (res.code == 1) {
                            this.list = res.data.recommendList
                        }
                        console.log(res, 'res');
                    })
                } catch {
                    this.$message.error('获取数据失败，请刷新');
                }
            },
            onSwiper(swiper) {
                console.log(swiper);
            },
            onSlideChange() {
                console.log('slide change');
            },
            enterFn () {
                this.swiper.autoplay.stop()
            },
            leaveFn () {
                this.swiper.autoplay.start()
            }

        }
    }
</script>

<style scoped lang="scss">
    .header {
        .title {
            font-size: 30px;
            font-weight: bold;
            line-height: 38px;
            color: #262626;
        }
        .line {
            width: 20px;
            height: 2px;
            background: #333333;
            opacity: 1;
            margin-top: 20px;
        }
    }
    .more_area {
        margin-top: 48px;
        .more {
            width: 111px;
            height: 42px;
            border: 1px solid #262626;
            opacity: 1;
            border-radius: 2px;
            font-size: 16px;
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
            line-height: 22px;
            color: #262626;
            &:hover {
                background-color: #262626;
                color: #fff;
            }
        }
    }
    .hot {
        .swiper-container {
            width: 100%;
            height: 500px;
        }
        .msl-prev {
            width: 42px;
            height: 42px;
            background: #BFBFBF;
            border-radius: 2px;
            position: absolute;
            top: 200px;
            left: 0;
            z-index: 30;
            margin-top: 21px;
            .prev_icon {
                font-size: 18px;
                color: #fff;
            }
            &:hover {
                background: #262626;
                .prev_icon, .next_icon {
                }
            }
        }
        .msl-next {
            width: 42px;
            height: 42px;
            background: #BFBFBF;
            border-radius: 2px;
            position: absolute;
            top: 200px;
            right: 0;
            z-index: 30;
            margin-top: 21px;
            .next_icon {
                font-size: 18px;
                color: #fff;
            }
            &:hover {
                background: #262626;
                .next_icon, .next_icon {
                }
            }
        }
        .hot_center {
            padding: 50px 0;
            box-sizing: border-box;
            .hot_content {
                overflow: visible;
                margin-top: 48px;
                .p_item {
                    width: 400px;
                    margin-right: 32px;
                    &:last-child {
                        margin-right: 0;
                    }
                    &:hover {
                        img {
                            transform: scale(1.05);
                            transition: all 0.6s;
                        }
                    }
                    .mask {
                        width: 100%;
                        height: 100%;
                        z-index: 100;
                        padding: 32px;
                        box-sizing: border-box;

                        .buy_btn {
                            width: 50%;
                            height: 48px;
                            border-radius: 6px;
                            border: 1px solid #262626;
                            color: #262626;
                            font-size: 18px;
                            font-weight: 500;
                            display: none;
                        }
                    }

                    .img_box {
                        width: 400px;
                        height:400px;
                        overflow: hidden;
                        &:hover {
                            /*.mask {*/
                            /*    background-color: rgba(255, 255, 255, .8);*/
                            /*    .buy_btn {*/
                            /*        display: flex;*/

                            /*        &:hover {*/
                            /*            background-color: #262626;*/
                            /*            color: #fff;*/
                            /*        }*/
                            /*    }*/
                            /*}*/
                            /*img {*/
                            /*    transform: scale(1.05);*/
                            /*    transition: all 0.6s;*/
                            /*}*/
                        }

                        img {
                            width: 100%;
                            height: 100%;
                            transition: all 0.6s;
                        }
                    }



                    .txt {
                        margin-top: 32px;
                        .title {
                            font-size: 20px;
                            font-weight: 400;
                            line-height: 28px;
                            color: #262626;
                        }
                        .price {
                            margin-top: 12px;
                            font-size: 16px;
                            font-weight: bold;
                            line-height: 28px;
                            color: #262626;
                        }
                    }
                }
            }
        }
    }
</style>
